
(() => {
  function initCSCCart() {
    const root = document.getElementById('CSC-CustomCart');
    if (!root || root.dataset.cscInitialized === 'true') return;
    root.dataset.cscInitialized = 'true';

    const panel = root.querySelector('.csc-cart__panel');
    const itemsBox = root.querySelector('[data-csc-items]');
    const emptyBox = root.querySelector('[data-csc-empty]');
    const footer = root.querySelector('[data-csc-footer]');
    const errorBox = root.querySelector('[data-csc-error]');
    const countBox = root.querySelector('[data-csc-count]');
    const subtotalBox = root.querySelector('[data-csc-subtotal]');
    const discountRow = root.querySelector('[data-csc-discount-row]');
    const discountBox = root.querySelector('[data-csc-discount]');
    const promoForm = root.querySelector('[data-csc-promo-form]');
    const promoInput = root.querySelector('[data-csc-promo-input]');
    const promoButton = root.querySelector('[data-csc-promo-button]');
    const promoMessage = root.querySelector('[data-csc-promo-message]');
    const totalBox = root.querySelector('[data-csc-total]');

    const cartUrl = root.dataset.cartUrl || '/cart';
    const addUrl = root.dataset.cartAddUrl || '/cart/add';
    const changeUrl = root.dataset.cartChangeUrl || '/cart/change';
    const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
    const discountUrl = root.dataset.discountUrl || '/discount/';
    const shippingGoal = Number(root.dataset.cscShippingGoal || 3000000);

    let busy = false;
    let couponBusy = false;
    let lastFocused = null;

    const money = (cents) =>
      new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);

    const escapeHTML = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[char]);

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message || 'Something went wrong. Please try again.';
      errorBox.hidden = false;
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function showPromoMessage(message, type) {
      if (!promoMessage) return;
      promoMessage.textContent = message || '';
      promoMessage.hidden = !message;
      promoMessage.classList.toggle('is-error', type === 'error');
      promoMessage.classList.toggle('is-success', type === 'success');
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('csc-cart-open');
      if (panel) panel.focus();
    }

    function closeDrawer() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('csc-cart-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function updateHeaderCount(cart) {
      const count = Number(cart.item_count || 0);

      document.querySelectorAll(
        '[data-csa-cart-count], [data-csc-cart-count]'
      ).forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count < 1;
      });

      document.querySelectorAll('#cart-icon-bubble .cart-count-bubble')
        .forEach((badge) => {
          badge.hidden = count < 1;
          const spans = badge.querySelectorAll('span');
          if (spans[0]) spans[0].textContent = count;
        });
    }

    function renderShippingProgress(cart) {
      const bar = root.querySelector('[data-csc-shipping]');
      const message = root.querySelector('[data-csc-shipping-message]');
      const icon = root.querySelector('[data-csc-shipping-icon]');
      const progress = root.querySelector('[data-csc-progress]');
      const fill = root.querySelector('[data-csc-progress-fill]');

      const value = Number(
        cart.original_total_price ?? cart.items_subtotal_price ?? 0
      );
      const remaining = Math.max(0, shippingGoal - value);

      
const shippingAssemblyRow = root.querySelector('[data-csc-shipping-assembly]');

if (shippingAssemblyRow) {
  shippingAssemblyRow.hidden = remaining > 0;
}


      const percent = shippingGoal > 0
        ? Math.min(100, (value / shippingGoal) * 100)
        : 100;

      if (message) {
        message.innerHTML = remaining > 0
          ? `Add <strong>${money(remaining)}</strong> worth of products to unlock Free Express Shipping &amp; Free Assembly!`
          : '<strong>Free Express Shipping &amp; Free Assembly unlocked!</strong>';
      }

      if (icon) icon.textContent = remaining > 0 ? '+' : '✓';
      if (fill) fill.style.width = `${percent}%`;

      if (progress) {
        progress.setAttribute('aria-valuemax', String(shippingGoal / 100));
        progress.setAttribute('aria-valuenow', String(value / 100));
        progress.setAttribute('aria-valuetext', `${Math.round(percent)}% complete`);
      }

      if (bar) bar.classList.toggle('is-unlocked', remaining <= 0);
    }

    function renderCart(cart) {
      const items = cart.items || [];
      renderShippingProgress(cart);

      if (countBox) countBox.textContent = `(${cart.item_count || 0})`;

      if (subtotalBox) {
        subtotalBox.textContent = money(
          cart.original_total_price ?? cart.items_subtotal_price
        );
      }

      if (totalBox) totalBox.textContent = money(cart.total_price);

      const totalDiscount = Number(cart.total_discount || 0);
      if (discountRow) discountRow.hidden = totalDiscount <= 0;
      if (discountBox) {
        discountBox.textContent = totalDiscount > 0
          ? '−' + money(totalDiscount)
          : '−₹0';
      }

      if (itemsBox) itemsBox.replaceChildren();

      if (!items.length) {
        if (emptyBox) emptyBox.hidden = false;
        if (footer) footer.hidden = true;
        if (itemsBox) itemsBox.hidden = true;
        return;
      }

      if (emptyBox) emptyBox.hidden = true;
      if (footer) footer.hidden = false;
      if (itemsBox) itemsBox.hidden = false;

      items.forEach((item) => {
        const image = item.featured_image?.url || item.image || '';
        const quantity = Number(item.quantity || 1);

        // Shopify cart.js supplies unit prices and line prices separately.
        const originalUnit = Number(item.original_price ?? item.price ?? 0);
        const finalUnit = Number(item.final_price ?? item.price ?? 0);
        const originalLine = Number(
          item.original_line_price ?? originalUnit * quantity
        );
        const finalLine = Number(
          item.final_line_price ?? finalUnit * quantity
        );

        const lineDiscounted = originalLine > finalLine;
        const lineAllocations = Array.isArray(item.line_level_discount_allocations)
          ? item.line_level_discount_allocations
          : [];
        const hasLineDiscount = lineDiscounted || lineAllocations.length > 0;

        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="csc-cart__variant">${escapeHTML(item.variant_title)}</p>`
            : '';

        // Regular price + sale price, using unit prices.
        const priceHTML = lineDiscounted
          ? `<div class="csc-cart__price">
               <span style="text-decoration:line-through;color:#777;font-size:13px;font-weight:400;margin-right:6px;">
                 ${money(originalUnit)}
               </span>
               <span style="color:#8a4315;font-weight:700;">
                 ${money(finalUnit)}
               </span>
               <span style="display:block;color:#00834b;font-size:12px;font-weight:500;">
                 Discount applied
               </span>
             </div>`
          : `<div class="csc-cart__price">
               ${money(finalUnit)}
               ${hasLineDiscount
                 ? '<span style="display:block;color:#00834b;font-size:12px;font-weight:500;">Discount applied</span>'
                 : ''}
             </div>`;

        const article = document.createElement('article');
        article.className = 'csc-cart__item';

        article.innerHTML = `
          <a href="${escapeHTML(item.url || '#')}"
             aria-label="${escapeHTML(item.product_title)}">
            ${
              image
                ? `<img class="csc-cart__image"
                        src="${escapeHTML(image)}"
                        alt="${escapeHTML(item.product_title)}"
                        loading="lazy">`
                : '<span class="csc-cart__image"></span>'
            }
          </a>

          <div class="csc-cart__item-info">
            <a class="csc-cart__product-title"
               href="${escapeHTML(item.url || '#')}">
              ${escapeHTML(item.product_title)}
            </a>
            ${variant}
            ${priceHTML}

            <div class="csc-cart__quantity" aria-label="Quantity controls">
              <button type="button" data-csc-qty="-1"
                data-csc-key="${escapeHTML(item.key)}"
                aria-label="Decrease quantity">−</button>
              <span>${quantity}</span>
              <button type="button" data-csc-qty="1"
                data-csc-key="${escapeHTML(item.key)}"
                aria-label="Increase quantity">+</button>
            </div>
          </div>

          <button class="csc-cart__remove" type="button"
            data-csc-remove="${escapeHTML(item.key)}"
            aria-label="Remove ${escapeHTML(item.product_title)}">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 7h16M9 7V4h6v3m-9 0 1 14h10l1-14M10 10v7m4-7v7"
                stroke="currentColor" stroke-width="1.7"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        `;

        itemsBox.appendChild(article);
      });
    }

    async function getCart() {
      const response = await fetch(cartUrl + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Unable to load your cart.');
      return response.json();
    }

    async function refreshCart() {
      try {
        clearError();
        const cart = await getCart();
        renderCart(cart);
        updateHeaderCount(cart);
        return cart;
      } catch (error) {
        showError(error.message);
        return null;
      }
    }

    async function applyCoupon() {
      if (!promoInput || !promoButton || couponBusy) return;

      const code = promoInput.value.trim();
      if (!code) {
        showPromoMessage('Please enter a discount code.', 'error');
        return;
      }

      couponBusy = true;
      promoButton.disabled = true;
      const originalText = promoButton.textContent;
      promoButton.textContent = 'Applying…';
      showPromoMessage('', '');

      try {
        const response = await fetch(
          `${discountUrl}${encodeURIComponent(code)}?redirect=%2Fcart`,
          {
            method: 'GET',
            credentials: 'same-origin',
            redirect: 'follow',
            cache: 'no-store'
          }
        );

        if (!response.ok) throw new Error('Unable to apply the discount code.');

        const cart = await getCart();
        renderCart(cart);
        updateHeaderCount(cart);

        if (Number(cart.total_discount || 0) > 0) {
          showPromoMessage(
            `Code ${code.toUpperCase()} applied. Cart discount: ${money(cart.total_discount)}.`,
            'success'
          );
        } else {
          showPromoMessage(
            'No discount was applied. Check the code and product eligibility.',
            'error'
          );
        }
      } catch (error) {
        showPromoMessage(error.message || 'Unable to apply discount.', 'error');
      } finally {
        couponBusy = false;
        promoButton.disabled = false;
        promoButton.textContent = originalText;
      }
    }

    async function changeQuantity(key, quantity) {
      if (busy) return;
      busy = true;
      clearError();

      try {
        const response = await fetch(changeUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to update cart.');
        }

        renderCart(result);
        updateHeaderCount(result);
      } catch (error) {
        showError(error.message);
        await refreshCart();
      } finally {
        busy = false;
      }
    }

    async function addProduct(form) {
      if (busy) return;
      busy = true;
      clearError();

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        const formData = new FormData(form);
        if (!formData.get('id')) {
          throw new Error('Please select a product variant first.');
        }

        const response = await fetch(addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: formData
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to add product.');
        }

        const cart = await getCart();
        renderCart(cart);
        updateHeaderCount(cart);
        openDrawer();
      } catch (error) {
        showError(error.message);
        openDrawer();
      } finally {
        busy = false;
        if (submitButton) submitButton.disabled = false;
      }
    }

    if (promoForm) {
      promoForm.addEventListener('submit', (event) => {
        event.preventDefault();
        applyCoupon();
      });
    }

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-csc-close]')) {
        closeDrawer();
        return;
      }

      const removeButton = event.target.closest('[data-csc-remove]');
      if (removeButton) {
        changeQuantity(removeButton.dataset.cscRemove, 0);
        return;
      }

      const quantityButton = event.target.closest('[data-csc-qty]');
      if (quantityButton) {
        const article = quantityButton.closest('.csc-cart__item');
        const quantity = Number(
          article?.querySelector('.csc-cart__quantity span')?.textContent || 1
        );

        changeQuantity(
          quantityButton.dataset.cscKey,
          Math.max(0, quantity + Number(quantityButton.dataset.cscQty))
        );
        return;
      }

      if (event.target.closest('[data-csc-checkout]')) {
        window.location.href = checkoutUrl;
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const productForm = form.closest('product-form');
      const action = form.getAttribute('action') || '';

      if (!productForm && !/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) return;
      if (!form.querySelector('[name="id"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addProduct(form);
    }, true);

    document.addEventListener('click', (event) => {
      const cartLink = event.target.closest(
        '#CSA-header-cart, .CSA-header__cart, [data-csc-open-cart]'
      );
      if (!cartLink) return;

      event.preventDefault();
      event.stopPropagation();
      openDrawer();
      refreshCart();
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    document.addEventListener('cart:refresh', (event) => {
      if (!event.detail?.cart) return;
      renderCart(event.detail.cart);
      updateHeaderCount(event.detail.cart);
    });

    document.addEventListener('shopify:section:load', refreshCart);

    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCSCCart);
  } else {
    initCSCCart();
  }
})();
